import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ConfigProvider, Menu, MenuProps } from 'antd';
import cn from 'classnames';

import { useMedia } from 'shared/hooks';
import { EInternalLinks } from 'shared/typings';

import styles from './FooterNav.module.scss';

interface IFooterNavProps extends MenuProps {}

export const FooterNav: FC<IFooterNavProps> = ({ className, ...props }) => {
	const { t } = useTranslation();
	const isMd = useMedia();

	const FOOTER_ITEMS = [
		{
			key: EInternalLinks.HELP,
			label: (
				<a href={EInternalLinks.HELP} target="_blank">
					{t('Центр помощи')}
				</a>
			),
		},
		{
			key: EInternalLinks.PRIVACY,
			label: (
				<a href={EInternalLinks.PRIVACY} target="_blank">
					{t('Политика приватности')}
				</a>
			),
		},
		{
			key: EInternalLinks.TERMS_OF_USE,
			label: (
				<a href={EInternalLinks.TERMS_OF_USE} target="_blank">
					{t('Пользовательское соглашение')}
				</a>
			),
		},
	];

	return (
		<ConfigProvider
			theme={{
				components: {
					Menu: {
						itemHeight: 36,
						itemPaddingInline: 12,
					},
				},
			}}>
			<Menu
				{...props}
				className={cn(className, styles.footerNav)}
				items={FOOTER_ITEMS}
				mode={isMd ? 'vertical' : 'horizontal'}
				inlineCollapsed={false}
				selectable={false}
			/>
		</ConfigProvider>
	);
};
